import React, { useEffect, useState, useRef } from "react";
import { Edit, X, XIcon, UploadIcon } from "lucide-react";
import "./Css/Reservations.css";
import "./Css/aplicationform.css";
import Header from "./Header";
import Loader from "./Loader.js";
import "react-datepicker/dist/react-datepicker.css";
import { Upload, Pen, Trash2 } from "lucide-react";
import DatePicker from "react-datepicker";
import SignatureCanvas from "react-signature-canvas";
import { useLocation } from "react-router-dom";
import {
  APL_LINK,
  server_post_data,
  create_walkIn_booking,
  get_car_walkin_booking,
  upload_image_to_folder,
} from "../ServiceConnection/serviceconnection";
import {
  handleError,
  handleNumbersChange,
  handleSuccessSession,
  formatToYYYYMMDD,
} from "../CommonJquery/CommonJquery.js";
import Select from "react-select";
import { toast } from "react-toastify";
let click_type = 0;
function CreateReservation() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const location = useLocation();
  const data = location.state;
  const pathname = location.pathname;
  const pathParts = pathname.split("/"); // split into parts
  const pathName = pathParts[1]; // "Create_WalkInSwitch"
  const datafromId = pathParts[2] || 0;
  const maxDob = new Date();
  const [numberOfDays, setNumberOfDays] = useState(null);
  const [totalCost, setTotalCost] = useState(null);
  maxDob.setFullYear(maxDob.getFullYear() - 16);
  const [step, setStep] = useState(1);
  const [getcardata, setgetcardata] = useState([]);
  const [carState, setCarState] = useState("");
  const [errors, setErrors] = useState({});
  const [bookingdata, setbookingdata] = useState([]);
  const [imagelink, setimagelink] = useState([]);
  const [drivingLicence, setdrivingLicence] = useState(null);
  const [rideShareImage, setrideShareImage] = useState(null);
  const [mvrPdf, setMvrPdf] = useState([]);
  const [DrivingLink, setDrivingLink] = useState("");
  const [DamageImg, setDamageImg] = useState([]);
  const [uploadedDamageImages, setUploadedDamageImages] = useState([]);
  const [DringImg, SetDringImg] = useState();
  const [hasDrawn, setHasDrawn] = useState(false); // Track drawing state
  const [activeSignatureType, setActiveSignatureType] = useState("canvas"); // "canvas" | "uploaded" | "existing"
  const [formData, setFormData] = useState(() => ({
    mvrDownloaded: "yes",
    // mvrFile: [],
    driving_licence_image: "",
    feeAgreement: "",
    pickupDate: "",
    firstName: "",
    lastName: "",
    dob: "",
    city: "",
    drivingState: "",
    licenseExpiry: "",
    zipcode: "",
    phone: "",
    address: "",
    email: "",
    rideshareApproval: "no",
    hireExperience: "",
    carPreference: [],
    rentalDuration: "",
    // rentalStart: "",
    carUsage: [],
    carUsageOther: "",
    workApproval: [],
    workApprovalOther: "",
    submissionDate: "",
    signature_image: null,
    rideshare_aproval_image: null,
  }));
  // console.log(formData);
  // console.log(errors);
  const usStates = [
    { name: "Alabama", abbr: "AL" },
    { name: "Alaska", abbr: "AK" },
    { name: "Arizona", abbr: "AZ" },
    { name: "Arkansas", abbr: "AR" },
    { name: "California", abbr: "CA" },
    { name: "Colorado", abbr: "CO" },
    { name: "Connecticut", abbr: "CT" },
    { name: "Delaware", abbr: "DE" },
    { name: "Florida", abbr: "FL" },
    { name: "Georgia", abbr: "GA" },
    { name: "Hawaii", abbr: "HI" },
    { name: "Idaho", abbr: "ID" },
    { name: "Illinois", abbr: "IL" },
    { name: "Indiana", abbr: "IN" },
    { name: "Iowa", abbr: "IA" },
    { name: "Kansas", abbr: "KS" },
    { name: "Kentucky", abbr: "KY" },
    { name: "Louisiana", abbr: "LA" },
    { name: "Maine", abbr: "ME" },
    { name: "Maryland", abbr: "MD" },
    { name: "Massachusetts", abbr: "MA" },
    { name: "Michigan", abbr: "MI" },
    { name: "Minnesota", abbr: "MN" },
    { name: "Mississippi", abbr: "MS" },
    { name: "Missouri", abbr: "MO" },
    { name: "Montana", abbr: "MT" },
    { name: "Nebraska", abbr: "NE" },
    { name: "Nevada", abbr: "NV" },
    { name: "New Hampshire", abbr: "NH" },
    { name: "New Jersey", abbr: "NJ" },
    { name: "New Mexico", abbr: "NM" },
    { name: "New York", abbr: "NY" },
    { name: "North Carolina", abbr: "NC" },
    { name: "North Dakota", abbr: "ND" },
    { name: "Ohio", abbr: "OH" },
    { name: "Oklahoma", abbr: "OK" },
    { name: "Oregon", abbr: "OR" },
    { name: "Pennsylvania", abbr: "PA" },
    { name: "Rhode Island", abbr: "RI" },
    { name: "South Carolina", abbr: "SC" },
    { name: "South Dakota", abbr: "SD" },
    { name: "Tennessee", abbr: "TN" },
    { name: "Texas", abbr: "TX" },
    { name: "Utah", abbr: "UT" },
    { name: "Vermont", abbr: "VT" },
    { name: "Virginia", abbr: "VA" },
    { name: "Washington", abbr: "WA" },
    { name: "West Virginia", abbr: "WV" },
    { name: "Wisconsin", abbr: "WI" },
    { name: "Wyoming", abbr: "WY" },
    { name: "District of Columbia", abbr: "DC" },
  ];
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "phone") {
      // Remove non-digit characters and limit to 10 digits
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
      // Format for display: (XXX) XXX-XXXX
      let formattedValue = digitsOnly;
      if (digitsOnly.length > 3 && digitsOnly.length <= 6) {
        formattedValue = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(3)}`;
      } else if (digitsOnly.length > 6) {
        formattedValue = `(${digitsOnly.slice(0, 3)}) ${digitsOnly.slice(
          3,
          6,
        )}-${digitsOnly.slice(6)}`;
      }
      // Save digits only, but also keep formatted for display
      setFormData((prev) => ({
        ...prev,
        [name]: digitsOnly, // clean numeric data
        [`${name}Display`]: formattedValue, // formatted display value
      }));
    } else if (name === "zipcode") {
      // Remove non-digit characters and limit to 10 digits
      const formattedZip = value.replace(/\D/g, "").slice(0, 10);
      setFormData({ ...formData, [name]: formattedZip });
    } else if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked
          ? [...prevData[name], value]
          : prevData[name].filter((item) => item !== value),
      }));
    } else if (type === "file") {
      if (name === "driving_licence_image") {
        setdrivingLicence(e.target.files[0]);
      }
      if (name === "rideshare_aproval_image") {
        setrideShareImage(e.target.files[0]);
      }
      setFormData({ ...formData, [name]: e.target.files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const uploadImageserver = async (file, index) => {
    const fd = new FormData();
    fd.append("image", file);
    fd.append("image_tag", "mvr_image");
    try {
      const response = await server_post_data(upload_image_to_folder, fd);
      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const uploadedImageName = response.data.message.image_uploaded;
        // add to uploadedDamageImages array
        setUploadedDamageImages((prev) => {
          const newArr = [...prev, uploadedImageName];
          // also set formData.mvrFile to a truthy value to mark that MVR is uploaded
          setFormData((prevForm) => ({
            ...prevForm,
            mvrFile: newArr.length > 0 ? newArr : "",
          }));
          return newArr;
        });
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };
  const handleFileChangeMVR = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + uploadedDamageImages.length > 3) {
      alert("You can only upload a maximum of 3 images.");
      return;
    }
    const remainingSlots = 3 - uploadedDamageImages.length;
    const filesToUpload = files.slice(0, remainingSlots);
    // Start uploading each file. uploadImageserver will update uploadedDamageImages and formData.mvrFile
    filesToUpload.forEach((file, index) => {
      uploadImageserver(file, index);
    });
  };
  useEffect(() => {
    // Check if 'data' is defined and has 'endDate' and 'fromDate'
    if (!data || !data.endDate || !data.fromDate) {
      console.error("Dates are missing or 'data' is not available.");
      return;
    }
    const endDate = new Date(data.endDate);
    const fromDate = new Date(data.fromDate);
    if (isNaN(endDate) || isNaN(fromDate)) {
      console.error("Invalid date format.");
      return;
    }
    const differenceInTime = endDate - fromDate;
    let daysDifference = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));
    if (daysDifference === 0) {
      daysDifference = 1;
    }
    if (daysDifference > 0) {
      setNumberOfDays(daysDifference);
      const carPrice = Number(data.car_price);
      const total = daysDifference * carPrice;
      setTotalCost(total);
    } else {
      console.error("End date is earlier than the from date.");
    }
  }, [data?.endDate, data?.fromDate]);
  const step1Errors = () => {
    let errors = {};
    if (!carState || carState === "") {
      errors.car = "Please select a car.";
    }
    if (formData.mvrDownloaded === "yes" && !formData.mvrFile)
      errors.mvrFile = "Please upload the MVR file.";
    if (!formData.firstName) errors.firstName = "First name is required.";
    if (!formData.lastName) errors.lastName = "Last name is required.";
    if (!formData.phone) {
      errors.phone = "Phone number is required.";
    } else {
      // Remove any non-digit characters
      const phoneNumber = formData.phone.replace(/\D/g, "");
      // Check if the phone number is exactly 10 digits
      if (phoneNumber.length !== 10) {
        errors.phone = "Phone number must be 10 digits long.";
      } else {
        // Additional validation for common US phone number formats
        const firstThreeDigits = phoneNumber.substring(0, 3);
        const invalidAreaCodes = ["000", "111", "911"];
        if (invalidAreaCodes.includes(firstThreeDigits)) {
          errors.phone = "Invalid phone number format.";
        }
      }
    }
    if (!formData.email) errors.email = "Email is required.";
    if (!formData.address) errors.address = "Street Address is required.";
    if (!formData.city) errors.city = "City is required.";
    if (!formData.zipcode) errors.zipcode = "Zipcode is required.";
    if (!formData.drivingState) errors.drivingState = "Please select a state.";
    return errors;
  };
  // const handleNext = () => setStep(step + 1);
  const handleNext = () => {
    const errors = step1Errors();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      window.scroll(0, 0);
      toast.error(
        "Form submission failed. Please review the highlighted fields and correct the errors.",
      );
      return;
    }
    setStep(step + 1);
  };
  const handleBack = () => setStep(step - 1);
  const signaturePad = useRef(null);
  const [signatureData, setSignatureData] = useState(null);
  const handleClearSignature = () => {
    if (signaturePad.current) {
      signaturePad.current.clear();
      setSignatureData(null);
    }
  };
  // Signature save karne ke liye
  const handleSignatureEnd = () => {
    if (signaturePad.current && !signaturePad.current.isEmpty()) {
      const dataURL = signaturePad.current.toDataURL();
      setSignatureData(dataURL);
      // console.log("Signature saved:", dataURL);
    }
  };
  const validateForm = () => {
    let newErrors = {};
    // Other validations
    if (!formData.rideshareApproval)
      newErrors.rideshareApproval = "This field is required.";
    if (formData.rideshareApproval === "yes" && !formData.hireExperience) {
      newErrors.hireExperience = "Experience is required.";
    }
    if (
      formData.rideshareApproval !== "yes" &&
      formData.carUsage.length === 0
    ) {
      newErrors.carUsage = "Please select at least one usage.";
    }
    if (formData.carUsage.includes("Other") && !formData.carUsageOther)
      newErrors.carUsageOther = "Specify other car usage.";
    if (
      formData.workApproval.length === 0 &&
      formData.rideshareApproval === "yes"
    )
      newErrors.workApproval = "Please select at least one approval.";
    if (formData.workApproval.includes("Other") && !formData.workApprovalOther)
      newErrors.workApprovalOther = "Specify other platform.";
    setErrors(newErrors);
    //// console.log("Errors inside validateForm:", newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const fileInputRef = useRef(null);
  const [uploadedSignature, setUploadedSignature] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false);
  //// console.log("uploadedSignature", uploadedSignature);
  const handleUploadClick = () => {
    fileInputRef.current.click(); // open file picker
  };
  // };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/heic",
        "image/heif",
      ];
      if (!allowedTypes.includes(file.type)) {
        alert("Please upload only image files (jpg, jpeg, png)");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedSignature(reader.result);
        setFormData((prev) => ({ ...prev, signature_image: file }));
        // Sabse important: ab yeh set karo
        setActiveSignatureType("uploaded");
        setIsUploaded(true);
      };
      reader.readAsDataURL(file);
    }
  };
  // const handleDeleteUpload = () => {
  // setUploadedSignature(null);
  // setIsUploaded(false);
  // };
  const handleDeleteUpload = () => {
    setUploadedSignature(null);
    setIsUploaded(false);
    setFormData((prev) => ({ ...prev, signature_image: null }));
    setActiveSignatureType("canvas"); // Wapas canvas dikhao
    if (signaturePad.current) {
      signaturePad.current.clear();
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  const getSignatureFile = () => {
    if (signaturePad.current && !signaturePad.current.isEmpty()) {
      const dataURL = signaturePad.current.toDataURL("image/png");
      const base64String = dataURL.split(",")[1];
      const byteArray = new Uint8Array(
        atob(base64String)
          .split("")
          .map((c) => c.charCodeAt(0)),
      );
      const blob = new Blob([byteArray], { type: "image/png" });
      return new File([blob], "signature.png", { type: "image/png" });
    }
    return null;
  };
  const handleSubmitImg = async (signatureFile) => {
    setshowLoaderAdmin(true);
    if (click_type == 0) {
      click_type = 1;
      let fd_from = new FormData();
      // Handle signature
      if (signatureFile) {
        fd_from.append("signature_image", signatureFile);
      } else if (formData.signature_image) {
        fd_from.append("signature_image", formData.signature_image);
      } else if (uploadedSignature) {
        // If somehow uploadedSignature exists but formData.signature_image doesn't
        // Convert base64 to file
        const base64String = uploadedSignature.split(",")[1];
        const byteArray = new Uint8Array(
          atob(base64String)
            .split("")
            .map((c) => c.charCodeAt(0)),
        );
        const blob = new Blob([byteArray], { type: "image/png" });
        const file = new File([blob], "signature.png", { type: "image/png" });
        fd_from.append("signature_image", file);
      } else {
        alert("Please provide a signature before proceeding.");
        setshowLoaderAdmin(false);
        click_type = 0;
        return;
      }
      fd_from.append("pathname", pathName);
      fd_from.append("datafrom_id", datafromId);
      fd_from.append("emergency_contacts_relation1", "");
      fd_from.append("emergency_contacts_name1", "");
      fd_from.append("emergency_contacts1", "");
      fd_from.append("emergency_contacts_relation", "");
      fd_from.append("emergency_contacts_name", "");
      fd_from.append("emergency_contacts", "");
      fd_from.append("work_for", formData.workApproval);
      fd_from.append("long_need_car", formData.rentalDuration);
      fd_from.append("ready_for_rideshare", formData.rideshareApproval);
      if (formData.rideshareApproval === "no") {
        fd_from.append("passenger_for_hire_expe", "0");
      } else {
        fd_from.append("passenger_for_hire_expe", formData.hireExperience);
      }
      fd_from.append("driving_licence", "");
      fd_from.append("last_digit_ssn", "");
      fd_from.append("present_map_address", formData.address);
      fd_from.append("driving_expiration_date", "2025-01-01");
      fd_from.append("mvr_pdf", mvrPdf);
      fd_from.append("mvr_status", formData.mvrDownloaded);
      fd_from.append("driving_licence_image", drivingLicence);
      fd_from.append("rideshare_aproval_image", drivingLicence);
      fd_from.append("end_date", "2025-01-01");
      fd_from.append("pickup_date", formatToYYYYMMDD(formData.pickupDate));
      fd_from.append("car_id", carState.split("~@~")[0]);
      fd_from.append("car_price", carState.split("~@~")[0]);
      fd_from.append("total_price", 0);
      fd_from.append("phone_number", formData.phone);
      fd_from.append("email", formData.email);
      fd_from.append("dob", "2025-01-01");
      fd_from.append("last_name", formData.lastName);
      fd_from.append("first_name", formData.firstName);
      fd_from.append("state_dropdown", formData.drivingState);
      fd_from.append("city", formData.city);
      fd_from.append("pincode", formData.zipcode);
      fd_from.append("long_need_car", "");
      fd_from.append("using_car", formData.carUsage);
      fd_from.append("pathname", pathName);
      fd_from.append("datafrom_id", datafromId);
      fd_from.append("DamgeImage", JSON.stringify(uploadedDamageImages));
      await server_post_data(create_walkIn_booking, fd_from)
        .then((Response) => {
          if (Response.data.error) {
            handleError(Response.data.message);
            setshowLoaderAdmin(false);
          } else {
            handleSuccessSession(Response.data.message, "/Bookings");
            setshowLoaderAdmin(false);
          }
          click_type = 0;
        })
        .catch((error) => {
          click_type = 0;
          // console.log(error);
          setshowLoaderAdmin(false);
        });
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const isValid = validateForm();
    if (!isValid) {
      toast.error(
        "Form submission failed. Please review the highlighted fields and correct the errors.",
      );
      return;
    }

    // Sabse simple aur accurate check: activeSignatureType se pata karo
    if (activeSignatureType === "canvas") {
      // Agar canvas active hai → check karo ki sign kiya hai ya nahi
      if (signaturePad.current?.isEmpty()) {
        alert("Please provide a signature before submitting.");
        return;
      }
    } else if (
      activeSignatureType === "uploaded" ||
      activeSignatureType === "existing"
    ) {
      // Uploaded ya existing hai → already valid hai
      // Kuch karne ki zarurat nahi
    } else {
      alert("Please provide a signature before submitting.");
      return;
    }

    let signatureFile = null;

    // Agar canvas se sign kiya hai → convert to File
    if (activeSignatureType === "canvas") {
      const dataURL = signaturePad.current.toDataURL("image/png");
      const base64String = dataURL.split(",")[1];
      const byteArray = new Uint8Array(
        atob(base64String)
          .split("")
          .map((c) => c.charCodeAt(0)),
      );
      const blob = new Blob([byteArray], { type: "image/png" });
      signatureFile = new File([blob], "signature.png", { type: "image/png" });
    }
    // Agar uploaded ya existing hai → formData.signature_image mein already File ya filename hai

    handleSubmitImg(signatureFile);
  };
  useEffect(() => {
    master_data_get();
  }, []);
  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("pathname", pathName);
    fd.append("datafrom_id", datafromId);
    await server_post_data(get_car_walkin_booking, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          setgetcardata(Response.data.message.cardata);
          setbookingdata(Response.data.message.bookingdata);
          setimagelink(
            APL_LINK + Response.data.message.WEBSITE_IMAGE_USERIMAGELICENCE,
          );
          let booking_data = Response.data.message.bookingdata;
          console.log("Create_WalkInSwitch:", booking_data);
          // Extract images properly
          let damage_image = Response.data.message.damage_image;
          // Assuming `damage_image` is an array of objects with `.image`
          const extractedImages = damage_image.map((item) => item.image);
          // Set images in state
          setUploadedDamageImages(extractedImages);
          //// console.log("Booking Data:", Response.data);

          let workApprovalData = [];
          let workApprovalOtherData = "";
          let usingCarForData = [];
          let usingCarForOtherData = "";
          if (booking_data.work_for) {
            const [mainPart, otherPart] = booking_data.work_for.split("@~");
            workApprovalData = mainPart.split(",");
            workApprovalOtherData = otherPart || "";
            if (workApprovalOtherData) {
              workApprovalData.push("Other"); // Display "Other" in checkbox
            }
          }
          if (booking_data.using_car_for) {
            const [mainPart, otherPart] =
              booking_data.using_car_for.split("@~");
            usingCarForData = mainPart.split(",");
            usingCarForOtherData = otherPart;
            // console.log(usingCarForOtherData);
            if (usingCarForOtherData) {
              usingCarForData.push("Other"); // Display "Other" in checkbox
            }
          }
          // if (booking_data.signature_image) {
          //   setFormData((prev) => ({
          //     ...prev,
          //     signature_image: booking_data.signature_image,
          //   }));
          //   setActiveSignatureType("existing"); // Yeh sabse important hai
          // }
          // ── Pre-fill formData from existing booking ──────────────────────
          const phone = booking_data.mobile_no || "";
          let phoneDisplay = phone;
          if (phone.length > 6) {
            phoneDisplay = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
          } else if (phone.length > 3) {
            phoneDisplay = `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
          }

          setFormData((prev) => ({
            ...prev,
            firstName: booking_data.first_name || "",
            lastName: booking_data.last_name || "",
            phone: phone,
            phoneDisplay: phoneDisplay,
            email: booking_data.email || "",
            address: booking_data.present_map_address || "",
            city: booking_data.city || "",
            drivingState:
              booking_data.state_dropdown || booking_data.state || "",
            zipcode: booking_data.pin_code ? String(booking_data.pin_code) : "",
            pickupDate: booking_data.from_date || "", // already "YYYY-MM-DD"
            rideshareApproval: booking_data.ready_for_rideshare || "no",
            hireExperience: booking_data.passenger_for_hire_expe
              ? String(booking_data.passenger_for_hire_expe)
              : "",
            mvrDownloaded: booking_data.mvp_status || "no",
            rentalDuration: booking_data.long_need_car || "",
            driving_licence_image: booking_data.driving_licence_image || "",
            rideshare_aproval_image: booking_data.rideshare_aproval_image || "",
            // workApproval & carUsage handled separately below
            workApproval: workApprovalData,
            workApprovalOther: workApprovalOtherData,
            carUsage: usingCarForData,
            carUsageOther: usingCarForOtherData,
            signature_image: booking_data.signature_image || null,
          }));

          // ── Car selection ─────────────────────────────────────────────────
          if (booking_data.car_id) {
            // value format is  "primaryId~@~price"
            setCarState(
              `${booking_data.car_id}~@~${booking_data.per_day_rent}`,
            );
          }

          // ── Signature type ────────────────────────────────────────────────
          if (booking_data.signature_image) {
            setActiveSignatureType("existing");
          }

          setDrivingLink(
            APL_LINK + Response.data.message.WEBSITE_IMAGE_USERIMAGELICENCE,
          );
          // setDrivingLink(
          //   APL_LINK + Response.data.message.WEBSITE_IMAGE_USERIMAGELICENCE,
          // );
          // console.log(booking_data.using_car_for);
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };
  const [isEditing, setIsEditing] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [isEditing3, setIsEditing3] = useState(false);
  const handleEditClick = () => {
    setIsEditing(!isEditing);
    if (!isEditing) {
      setFormData((prevData) => ({
        ...prevData,
        // mvrFile: "",
      }));
    }
  };
  const handleEditClick2 = () => {
    setIsEditing2(!isEditing2);
    if (!isEditing2) {
      setFormData((prevData) => ({
        ...prevData,
        // driving_licence_image: "",
      }));
    }
  };
  const handleEditClick3 = () => {
    setIsEditing2(!isEditing2);
    if (!isEditing2) {
      setIsEditing3((prevData) => ({
        ...prevData,
        // driving_licence_image: "",
      }));
    }
  };
  const options = getcardata
    .filter((state) => state.status === 0)
    .map((state) => ({
      value: `${state.primary_id}~@~${state.Price}`,
      car_tagline: state.car_tagline,
      car_name: state.car_name,
      label: (
        <div>
          <span className="font-semibold">{state.car_tagline}</span> -{" "}
          {state.car_name}
        </div>
      ),
    }));
  const selectedOption = options.find((opt) => opt.value === carState) || null;
  const handleRemoveImage = (index) => {
    setUploadedDamageImages((prev) => {
      const updatedImages = prev.filter((_, i) => i !== index);
      // update formData.mvrFile accordingly: clear if no images left, otherwise keep array
      setFormData((prevForm) => ({
        ...prevForm,
        mvrFile: updatedImages.length > 0 ? updatedImages : "",
      }));
      return updatedImages;
    });
  };
  const handleImageError = () => {
    setIsUploaded(false);
    setFormData((prev) => ({ ...prev, signature_image: "" }));
  };
  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="pageCntn_head">
              <div className="walkInHead">
                <div className="walkInHeading">
                  <h5>Create Walk-In</h5>
                </div>
              </div>
            </div>
            <div className="page_body container-lg">
              <div>
                <div className="page-header pt-30 background-body">
                  <div className="container newFormContainer">
                    <div className="container">
                      <div className="mt-4 mb-4 form-container">
                        <form onSubmit={handleSubmit}>
                          {step === 1 && (
                            <div className="form-step">
                              <h6 className="mb-4">
                                Step 1: Basic Information
                              </h6>
                              <div className="row m-0">
                                {/* MVR Downloaded Question */}
                                <label className="col-md-6 mb-3">
                                  <span>
                                    Have you downloaded the MVR (For Court
                                    Purpose) and ready to upload?{" "}
                                  </span>
                                  {/* Radio buttons for Yes/No */}
                                  <div
                                    className="check_box_mvr"
                                    style={{ marginTop: "10px" }}
                                  >
                                    <input
                                      type="radio"
                                      id="mvrYes"
                                      name="mvrDownloaded"
                                      value="yes"
                                      checked={formData.mvrDownloaded === "yes"}
                                      onChange={(e) => {
                                        handleChange(e);
                                        setErrors((prevErrors) => ({
                                          ...prevErrors,
                                          mvrDownloaded: "",
                                        }));
                                      }}
                                    />
                                    <label
                                      htmlFor="mvrYes"
                                      style={{ marginRight: "20px" }}
                                    >
                                      Yes
                                    </label>
                                    <input
                                      type="radio"
                                      id="mvrNo"
                                      name="mvrDownloaded"
                                      value="no"
                                      checked={formData.mvrDownloaded === "no"}
                                      onChange={(e) => {
                                        handleChange(e);
                                        setErrors((prevErrors) => ({
                                          ...prevErrors,
                                          mvrDownloaded: "",
                                        }));
                                      }}
                                    />
                                    <label htmlFor="mvrNo">No</label>
                                  </div>
                                  {errors.mvrDownloaded && (
                                    <span className="error-message">
                                      {errors.mvrDownloaded}
                                    </span>
                                  )}
                                </label>
                                {formData.mvrDownloaded === "yes" && (
                                  <div className="col-md-6 mb-3">
                                    <p
                                      onClick={handleEditClick}
                                      style={{
                                        marginBottom: "0px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Upload MVR For Court Purpose
                                      <span style={{ color: "red" }}>
                                        *
                                      </span>{" "}
                                      {isEditing ? (
                                        <X
                                          size={17}
                                          style={{ cursor: "pointer" }}
                                        />
                                      ) : (
                                        <Edit
                                          size={17}
                                          style={{ cursor: "pointer" }}
                                        />
                                      )}
                                    </p>
                                    {/* {!formData.mvrFile || isEditing ? ( */}
                                    <div className="margin_reviewmodel">
                                      <div className="col-sm">
                                        <div className="img_upd_contr">
                                          <div
                                            className="media-placeholder upload_img_contr"
                                            onClick={() => {
                                              if (
                                                uploadedDamageImages.length < 4
                                              )
                                                document
                                                  .getElementById(
                                                    "damageFileInput",
                                                  )
                                                  .click();
                                            }}
                                            style={{
                                              opacity:
                                                uploadedDamageImages.length >= 4
                                                  ? 0.5
                                                  : 1,
                                              pointerEvents:
                                                uploadedDamageImages.length >= 4
                                                  ? "none"
                                                  : "auto",
                                            }}
                                          >
                                            <div className="empty-upload-text">
                                              <i className="bi bi-cloud-upload"></i>
                                              <span>Browse</span>
                                            </div>
                                            <input
                                              type="file"
                                              id="damageFileInput"
                                              accept="image/*"
                                              multiple
                                              style={{ display: "none" }}
                                              onChange={handleFileChangeMVR}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      {[...Array(3)].map((_, index) => (
                                        <div
                                          key={index}
                                          className="col-sm"
                                          style={{ position: "relative" }}
                                        >
                                          {uploadedDamageImages[index] &&
                                            uploadedDamageImages[index] !==
                                              "0" && (
                                              <div
                                                className="hoverRemoveImg"
                                                onClick={() =>
                                                  handleRemoveImage(index)
                                                }
                                              >
                                                <XIcon className="rmv_icn" />
                                              </div>
                                            )}
                                          <div className="media-placeholder car-image">
                                            {uploadedDamageImages[index] &&
                                            uploadedDamageImages[index] !==
                                              "0" ? (
                                              <img
                                                src={
                                                  imagelink +
                                                    uploadedDamageImages[
                                                      index
                                                    ] || "/placeholder.svg"
                                                }
                                                alt={`Damage ${index + 1}`}
                                                style={{
                                                  maxWidth: "100%",
                                                  maxHeight: "100%",
                                                }}
                                              />
                                            ) : (
                                              <div
                                                className="empty-upload-text"
                                                style={{ opacity: 0.5 }}
                                              >
                                                <UploadIcon
                                                  size={20}
                                                  color="#aaa"
                                                />
                                                <span
                                                  style={{
                                                    marginLeft: "10px",
                                                  }}
                                                >
                                                  Empty
                                                </span>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                    {/* ) : (
                                      <>
                                        {// console.log(
                                          "mvrFile_path",
                                          formData.mvrFile
                                        )}
                                        <a
                                          href={formData.mvrFile}
                                          className="DrivingImg"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          View Driver's MVR
                                        </a>
                                      </>
                                    )} */}
                                    {errors.mvrFile && (
                                      <span className="error-message">
                                        {errors.mvrFile}
                                      </span>
                                    )}
                                  </div>
                                )}
                                <div className="col-md-6 mb-3">
                                  <div className="d-flex flex-column">
                                    <span>Pickup Date *</span>
                                    <DatePicker
                                      // selected={
                                      //   formData.pickupDate
                                      //     ? new Date(formData.pickupDate)
                                      //     : null
                                      // }
                                      selected={
                                        formData.pickupDate
                                          ? (() => {
                                              const [year, month, day] =
                                                formData.pickupDate.split("-");
                                              return new Date(
                                                year,
                                                month - 1,
                                                day,
                                              );
                                            })()
                                          : null
                                      }
                                      onChange={(date) => {
                                        if (date) {
                                          // Get local date components
                                          const year = date.getFullYear();
                                          const month = String(
                                            date.getMonth() + 1,
                                          ).padStart(2, "0");
                                          const day = String(
                                            date.getDate(),
                                          ).padStart(2, "0");
                                          const localDateString = `${year}-${month}-${day}`;
                                          handleChange({
                                            target: {
                                              name: "pickupDate",
                                              value: localDateString,
                                            },
                                          });
                                        } else {
                                          handleChange({
                                            target: {
                                              name: "pickupDate",
                                              value: "",
                                            },
                                          });
                                        }
                                      }}
                                      name="pickupDate"
                                      className="form-control trio_mandatory"
                                      placeholderText="MM/DD/YYYY"
                                      dateFormat="MM-dd-yyyy"
                                      required
                                      minDate={new Date()}
                                    />
                                  </div>
                                  {errors.pickupDate && (
                                    <small className="text-danger">
                                      {errors.pickupDate}
                                    </small>
                                  )}
                                </div>
                                <div className="col-md-6 mb-3">
                                  <div className="d-flex flex-column">
                                    <span>
                                      Car{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <Select
                                      options={options}
                                      value={options.find(
                                        (opt) => opt.value === selectedOption,
                                      )}
                                      onChange={(selected) => {
                                        setCarState(selected?.value || "");
                                        if (selected?.value) {
                                          setErrors((prev) => ({
                                            ...prev,
                                            car: "",
                                          }));
                                        }
                                      }}
                                      placeholder="Select a car"
                                      isSearchable={true}
                                      // 👇 ensures search works
                                      getOptionLabel={(option) =>
                                        `${option.car_tagline} - ${option.car_name}`
                                      }
                                      getOptionValue={(option) => option.value}
                                      styles={{
                                        control: (base) => ({
                                          ...base,
                                          height: 42,
                                          backgroundColor: "#fff",
                                          borderColor: "#ddd",
                                          boxShadow: "none",
                                        }),
                                        option: (base, state) => ({
                                          ...base,
                                          backgroundColor: state.isFocused
                                            ? "#f1f1f1"
                                            : "#fff",
                                          color: "#333",
                                          cursor: "pointer",
                                        }),
                                      }}
                                    />
                                    {errors.car && (
                                      <span style={{ color: "red" }}>
                                        {errors.car}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <label
                                  key="firstName"
                                  className="col-md-6 mb-3"
                                >
                                  <span>
                                    First Name{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                  <input
                                    type="text"
                                    name="firstName"
                                    value={formData.firstName}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        firstName: "",
                                      }));
                                    }}
                                    onKeyPress={(e) => {
                                      if (!/^[a-zA-Z]*$/.test(e.key)) {
                                        e.preventDefault(); // Allow only alphabets
                                      }
                                    }}
                                    maxLength={12}
                                    required
                                    disabled={pathname.includes(
                                      "Create_WalkInSwitch",
                                    )}
                                  />
                                  {errors.firstName && (
                                    <span className="error-message">
                                      {errors.firstName}
                                    </span>
                                  )}
                                </label>
                                <label key="lastName" className="col-md-6 mb-3">
                                  <span>
                                    Last Name{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                  <input
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    maxLength={12}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        lastName: "",
                                      }));
                                    }}
                                    onKeyPress={(e) => {
                                      if (!/^[a-zA-Z]*$/.test(e.key)) {
                                        e.preventDefault(); // Allow only alphabets
                                      }
                                    }}
                                    required
                                    disabled={pathname.includes(
                                      "Create_WalkInSwitch",
                                    )}
                                  />
                                  {errors.lastName && (
                                    <span className="error-message">
                                      {errors.lastName}
                                    </span>
                                  )}
                                </label>
                                <label key="phone" className="col-md-6 mb-3">
                                  <span>
                                    Phone Number{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                  {/* <input
                                    type="tel"
                                    name="phone"
                                    maxLength={10}
                                    value={formData.phone}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        phone: "",
                                      }));
                                    }}
                                    onKeyPress={(e) => {
                                      if (!/^[0-9]*$/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    required
                                    disabled={pathname.includes(
                                      "Create_WalkInSwitch"
                                    )}
                                  /> */}
                                  <input
                                    type="tel"
                                    name="phone"
                                    maxLength={14}
                                    value={formData.phoneDisplay || ""}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        phone: "",
                                      }));
                                    }}
                                    onKeyPress={(e) => {
                                      if (!/^[0-9]*$/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    required
                                    disabled={pathname.includes(
                                      "Create_WalkInSwitch",
                                    )}
                                  />
                                  {errors.phone && (
                                    <span className="error-message">
                                      {errors.phone}
                                    </span>
                                  )}
                                </label>
                                <label key="email" className="col-md-6 mb-3">
                                  <span>
                                    Email{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                  <input
                                    type="email"
                                    name="email"
                                    maxLength={50}
                                    value={formData.email}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        email: "",
                                      }));
                                    }}
                                    required
                                    disabled={pathname.includes(
                                      "Create_WalkInSwitch",
                                    )}
                                    onKeyPress={(e) => {
                                      const allowedChars = /^[a-zA-Z0-9@.]*$/;
                                      if (!allowedChars.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onBlur={(e) => {
                                      const emailPattern =
                                        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                                      if (!emailPattern.test(e.target.value)) {
                                        setErrors({
                                          ...errors,
                                          email:
                                            "Please enter a valid email address",
                                        });
                                      }
                                    }}
                                  />
                                  {errors.email && (
                                    <span className="error-message">
                                      {errors.email}
                                    </span>
                                  )}
                                </label>
                                <label className="col-md-12 mb-3">
                                  <span>
                                    Present Address{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                  {/* Street Address */}
                                  <input
                                    type="text"
                                    name="address"
                                    placeholder="Street Address"
                                    value={formData.address}
                                    maxLength={100}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        address: "",
                                      }));
                                    }}
                                    required
                                    style={{
                                      display: "block",
                                      width: "100%",
                                      marginBottom: "10px",
                                    }}
                                  />
                                  {errors.address && (
                                    <span className="error-message">
                                      {errors.address}
                                    </span>
                                  )}
                                  {/* City */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      gap: "10px",
                                    }}
                                  >
                                    <div className="col">
                                      <input
                                        type="text"
                                        name="city"
                                        placeholder="City"
                                        value={formData.city}
                                        maxLength={50}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            city: "",
                                          }));
                                        }}
                                        required
                                        style={{
                                          display: "block",
                                          width: "100%",
                                          marginBottom: "10px",
                                        }}
                                      />
                                      {errors.city && (
                                        <span className="error-message">
                                          {errors.city}
                                        </span>
                                      )}
                                    </div>
                                    {/* State */}
                                    <div className="col">
                                      <select
                                        name="drivingState"
                                        value={formData.drivingState || ""}
                                        onChange={(e) => {
                                          handleChange(e);
                                          if (errors.drivingState) {
                                            setErrors((prevErrors) => ({
                                              ...prevErrors,
                                              drivingState: "",
                                            }));
                                          }
                                        }}
                                        required
                                        style={{
                                          backgroundColor: "#fff",
                                          height: "42px",
                                        }}
                                      >
                                        <option value="">Select a state</option>
                                        {usStates.map((state) => (
                                          <option
                                            key={state.name}
                                            value={state.name}
                                          >
                                            {state.name}
                                          </option>
                                        ))}
                                      </select>
                                      {errors.drivingState && (
                                        <span style={{ color: "red" }}>
                                          {errors.drivingState}
                                        </span>
                                      )}
                                    </div>
                                    {/* Zip Code */}
                                    <div className="col">
                                      <input
                                        type="text"
                                        name="zipcode"
                                        placeholder="Zip Code"
                                        value={formData.zipcode}
                                        maxLength={5}
                                        onChange={(e) => {
                                          handleChange(e);
                                          setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            zipcode: "",
                                          }));
                                        }}
                                        required
                                        style={{
                                          display: "block",
                                          width: "100%",
                                        }}
                                      />
                                      {errors.zipcode && (
                                        <span className="error-message">
                                          {errors.zipcode}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </label>
                                <div className="col-md-6 mb-3">
                                  <p
                                    onClick={handleEditClick2}
                                    style={{
                                      marginBottom: "0px",
                                      fontSize: "14px",
                                    }}
                                  >
                                    Upload Drivers License{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                    {isEditing2 ? (
                                      <X
                                        size={17}
                                        style={{ cursor: "pointer" }}
                                      />
                                    ) : (
                                      <Edit
                                        size={17}
                                        style={{ cursor: "pointer" }}
                                      />
                                    )}
                                  </p>
                                  {!formData.driving_licence_image ||
                                  isEditing2 ? (
                                    <input
                                      type="file"
                                      name="driving_licence_image"
                                      accept="image/*"
                                      className="form-control"
                                      onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                          handleChange(e);
                                          const imageUrl =
                                            URL.createObjectURL(file);
                                          setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            driving_licence_image: "",
                                          }));
                                          setFormData((prevFormData) => ({
                                            ...prevFormData,
                                            driving_licence_image: imageUrl,
                                          }));
                                        }
                                      }}
                                      required
                                    />
                                  ) : (
                                    <>
                                      {/* <img
                                        className="DrivingImg"
                                        src={formData.driving_licence_image}
                                        alt="Driving Licence"
                                      /> */}
                                      {drivingLicence !== null ? (
                                        <a
                                          href={formData.driving_licence_image}
                                          className="DrivingImg"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {" "}
                                          View Driver's Licence
                                        </a>
                                      ) : (
                                        <a
                                          href={
                                            DrivingLink +
                                            formData.driving_licence_image
                                          }
                                          className="DrivingImg"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {" "}
                                          View Driver's Licence
                                        </a>
                                      )}
                                    </>
                                  )}
                                  {errors.driving_licence_image && (
                                    <span style={{ color: "red" }}>
                                      {errors.driving_licence_image}
                                    </span>
                                  )}
                                </div>
                              </div>
                              {/* Submit Button */}
                              <div
                                className="submit-form-btn"
                                onClick={() => {
                                  handleNext(); // Proceed to the next step
                                }}
                              >
                                Next
                              </div>
                            </div>
                          )}
                          {step === 2 && (
                            <div className="form-step ">
                              <h6 className="mb-4">Step 2: Rental Details</h6>
                              <div className="row m-0">
                                <label className="col-md-6 mb-3">
                                  <span>
                                    Are you approved by any rideshare /
                                    delivery platform
                                    <span style={{ color: "red" }}>*</span>
                                  </span>
                                  {/* Radio buttons for Yes/No */}
                                  <div
                                    className="check_box_mvr"
                                    style={{ marginTop: "10px" }}
                                  >
                                    <input
                                      type="radio"
                                      id="rideshareApproval"
                                      name="rideshareApproval"
                                      value="yes"
                                      checked={
                                        formData.rideshareApproval === "yes"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                        setErrors((prevErrors) => ({
                                          ...prevErrors,
                                          rideshareApproval: "",
                                        }));
                                      }}
                                    />
                                    <label
                                      htmlFor="rideshareApproval"
                                      style={{ marginRight: "20px" }}
                                    >
                                      Yes
                                    </label>
                                    <input
                                      type="radio"
                                      id="rideshareApproval"
                                      name="rideshareApproval"
                                      value="no"
                                      checked={
                                        formData.rideshareApproval === "no"
                                      }
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (errors.rideshareApproval) {
                                          setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            rideshareApproval: "",
                                          }));
                                        }
                                      }}
                                    />
                                    <label htmlFor="mvrNo">No</label>
                                  </div>
                                  {errors.rideshareApproval && (
                                    <span style={{ color: "red" }}>
                                      {errors.rideshareApproval}
                                    </span>
                                  )}
                                </label>
                                {formData.rideshareApproval === "yes" && (
                                  <div className="col-md-6 mb-3">
                                    <p
                                      onClick={handleEditClick3}
                                      style={{
                                        marginBottom: "0px",
                                        fontSize: "14px",
                                      }}
                                    >
                                      Upload Rideshare Approval{" "}
                                      <span style={{ color: "red" }}>*</span>{" "}
                                      {isEditing3 ? (
                                        <X
                                          size={17}
                                          style={{ cursor: "pointer" }}
                                        />
                                      ) : (
                                        <Edit
                                          size={17}
                                          style={{ cursor: "pointer" }}
                                        />
                                      )}
                                    </p>
                                    {!formData.rideshare_aproval_image ||
                                    isEditing3 ? (
                                      <input
                                        type="file"
                                        name="rideshare_aproval_image"
                                        accept="image/*"
                                        className="form-control"
                                        onChange={(e) => {
                                          const file = e.target.files[0];
                                          if (file) {
                                            handleChange(e);
                                            const imageUrl =
                                              URL.createObjectURL(file);
                                            setErrors((prevErrors) => ({
                                              ...prevErrors,
                                              rideshare_aproval_image: "",
                                            }));
                                            setFormData((prevFormData) => ({
                                              ...prevFormData,
                                              rideshare_aproval_image: imageUrl,
                                            }));
                                          }
                                        }}
                                        required
                                      />
                                    ) : (
                                      <>
                                        {/* <img
                                        className="DrivingImg"
                                        src={formData.driving_licence_image}
                                        alt="Driving Licence"
                                      /> */}
                                        {rideShareImage !== null ? (
                                          <a
                                            href={
                                              formData.rideshare_aproval_image
                                            }
                                            className="DrivingImg"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {" "}
                                            View Rideshare Approval
                                          </a>
                                        ) : (
                                          <a
                                            href={
                                              DrivingLink +
                                              formData.rideshare_aproval_image
                                            }
                                            className="DrivingImg"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {" "}
                                            View Rideshare Approval
                                          </a>
                                        )}
                                      </>
                                    )}
                                    {errors.rideshare_aproval_image && (
                                      <span style={{ color: "red" }}>
                                        {errors.rideshare_aproval_image}
                                      </span>
                                    )}
                                  </div>
                                )}
                                {formData.rideshareApproval === "yes" && (
                                  <label className="col-md-6 mb-3">
                                    How many years of passenger-for-hire
                                    experience?{" "}
                                    <span style={{ color: "red" }}>*</span>
                                    <input
                                      type="text"
                                      name="hireExperience"
                                      value={formData.hireExperience}
                                      maxLength={2}
                                      onInput={handleNumbersChange}
                                      onChange={(e) => {
                                        handleChange(e);
                                        if (errors.hireExperience) {
                                          setErrors((prevErrors) => ({
                                            ...prevErrors,
                                            hireExperience: "",
                                          }));
                                        }
                                      }}
                                      required
                                    />
                                    {errors.hireExperience && (
                                      <span style={{ color: "red" }}>
                                        {errors.hireExperience}
                                      </span>
                                    )}
                                  </label>
                                )}
                                {formData.rideshareApproval === "no" && (
                                  <label className=" mb-3 usingCarSecDiv">
                                    <p className="subLabel">
                                      Using car for (Select all that apply){" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </p>
                                    <div>
                                      {[
                                        "Rideshare",
                                        "Commute to work",
                                        "Other",
                                      ].map((usage) => (
                                        <label key={usage}>
                                          <input
                                            type="checkbox"
                                            name="carUsage"
                                            value={usage}
                                            checked={formData.carUsage.includes(
                                              usage,
                                            )}
                                            onChange={(e) => {
                                              handleChange(e);
                                              if (errors.carUsage) {
                                                setErrors((prevErrors) => ({
                                                  ...prevErrors,
                                                  carUsage: "",
                                                }));
                                              }
                                            }}
                                          />
                                          {usage}
                                        </label>
                                      ))}
                                      {formData.carUsage.includes("Other") && (
                                        <input
                                          type="text"
                                          name="carUsageOther"
                                          placeholder="Specify other usage"
                                          defaultValue={formData.carUsageOther}
                                          onChange={handleChange}
                                        />
                                      )}
                                    </div>
                                    {errors.carUsage && (
                                      <span style={{ color: "red" }}>
                                        {errors.carUsage}
                                      </span>
                                    )}
                                  </label>
                                )}
                                {formData.rideshareApproval === "yes" && (
                                  <label className="col-md-6 mb-3 usingCarSecDiv">
                                    <p className="subLabel">
                                      Approved and ready to work for (Select all
                                      that apply)
                                      <span style={{ color: "red" }}>*</span>
                                    </p>
                                    <div>
                                      {[
                                        "Uber",
                                        "GIG Work",
                                        "Lyft",
                                        "Other",
                                      ].map((platform) => (
                                        <label key={platform}>
                                          <input
                                            type="checkbox"
                                            name="workApproval"
                                            value={platform}
                                            checked={formData.workApproval.includes(
                                              platform,
                                            )}
                                            onChange={(e) => {
                                              handleChange(e);
                                              if (errors.workApproval) {
                                                setErrors((prevErrors) => ({
                                                  ...prevErrors,
                                                  workApproval: "",
                                                }));
                                              }
                                            }}
                                          />
                                          {platform}
                                        </label>
                                      ))}
                                      {formData.workApproval.includes(
                                        "Other",
                                      ) && (
                                        <input
                                          type="text"
                                          name="workApprovalOther"
                                          placeholder="Specify other platform"
                                          value={formData.workApprovalOther}
                                          onChange={handleChange}
                                        />
                                      )}
                                    </div>
                                    {errors.workApproval && (
                                      <span style={{ color: "red" }}>
                                        {errors.workApproval}
                                      </span>
                                    )}
                                  </label>
                                )}
                                <div className="signature-section mt-3 col-md-12 mb-3 hidden">
                                  <div className="signUpdHead">
                                    <h6>Signature</h6>
                                    <div className="buttonsUpldDlt">
                                      {!isUploaded && (
                                        <Upload
                                          className="upload_icn"
                                          title="Upload Signature"
                                          size={19}
                                          onClick={handleUploadClick}
                                        />
                                      )}
                                      {isUploaded && (
                                        <Trash2
                                          className="dlt_icccn"
                                          title="Delete Image"
                                          size={19}
                                          onClick={handleDeleteUpload}
                                        />
                                      )}
                                      <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                  </div>
                                  {/* Signature Display */}
                                  {formData.signature_image ? (
                                    <img
                                      src={
                                        // formData.signature_image && formData.signature_image.includes(
                                        // "data:"
                                        // )
                                        // ? formData.signature_image
                                        // :
                                        APL_LINK +
                                        "assets/userimage/" +
                                        formData.signature_image
                                      }
                                      alt="Uploaded Signature"
                                      onError={handleImageError}
                                      style={{
                                        height: 180,
                                        width: 300,
                                        objectFit: "contain",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  ) : (
                                    <>
                                      {!isUploaded ? (
                                        <SignatureCanvas
                                          ref={signaturePad}
                                          penColor="black"
                                          onEnd={handleSignatureEnd} // ⭐ Yeh add karo
                                          canvasProps={{
                                            height: 200,
                                            width: 300,
                                            className:
                                              "signature-canvas border rounded",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={
                                            APL_LINK +
                                            "assets/userimage/" +
                                            formData.signature_image
                                          }
                                          alt="Uploaded Signature"
                                          onError={handleImageError}
                                          style={{
                                            height: 180,
                                            width: 300,
                                            objectFit: "contain",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                          }}
                                        />
                                      )}
                                    </>
                                  )}
                                  {/* Clear Button */}
                                  {!isUploaded && !formData.signature_image && (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        gap: "10px",
                                        alignItems: "center",
                                        justifyContent: "flex-start",
                                      }}
                                    >
                                      <div
                                        className="submit-form-btn-small"
                                        onClick={handleClearSignature}
                                      >
                                        Clear
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="signature-section mt-3 col-md-12 mb-3">
                                  <div className="signUpdHead">
                                    <h6>
                                      Signature{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </h6>
                                    <div className="buttonsUpldDlt">
                                      {activeSignatureType === "canvas" && (
                                        <Upload
                                          className="upload_icn"
                                          title="Upload Signature"
                                          size={19}
                                          onClick={handleUploadClick}
                                        />
                                      )}
                                      {activeSignatureType !== "canvas" && (
                                        <Trash2
                                          className="dlt_icccn"
                                          title="Delete Signature"
                                          size={19}
                                          onClick={handleDeleteUpload}
                                        />
                                      )}
                                      <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                      />
                                    </div>
                                  </div>

                                  {/* Signature Display */}
                                  {activeSignatureType === "uploaded" &&
                                    uploadedSignature && (
                                      <img
                                        src={uploadedSignature}
                                        alt="Uploaded Signature"
                                        style={{
                                          height: 180,
                                          width: 300,
                                          objectFit: "contain",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                        }}
                                      />
                                    )}

                                  {activeSignatureType === "existing" &&
                                    formData.signature_image && (
                                      <img
                                        src={
                                          APL_LINK +
                                          "assets/userimage/" +
                                          formData.signature_image
                                        }
                                        alt="Existing Signature"
                                        onError={() =>
                                          setActiveSignatureType("canvas")
                                        }
                                        style={{
                                          height: 180,
                                          width: 300,
                                          objectFit: "contain",
                                          border: "1px solid #ccc",
                                          borderRadius: "4px",
                                        }}
                                      />
                                    )}

                                  {activeSignatureType === "canvas" && (
                                    <>
                                      <SignatureCanvas
                                        ref={signaturePad}
                                        penColor="black"
                                        onEnd={handleSignatureEnd}
                                        canvasProps={{
                                          height: 200,
                                          width: 300,
                                          className:
                                            "signature-canvas border rounded",
                                        }}
                                      />
                                      <div
                                        style={{
                                          marginTop: "10px",
                                          display: "flex",
                                          gap: "10px",
                                        }}
                                      >
                                        <div
                                          className="submit-form-btn-small"
                                          onClick={handleClearSignature}
                                        >
                                          Clear
                                        </div>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "10px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <div
                                  className="submit-form-btn"
                                  onClick={handleBack}
                                >
                                  Back
                                </div>
                                <div
                                  className="submit-form-btn"
                                  onClick={handleSubmit}
                                >
                                  Submit
                                </div>
                              </div>
                            </div>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default CreateReservation;
